import { useMutation, useQueryClient } from '@tanstack/react-query'

import { ErrorResponse } from '@sparkai/utils'

import { apiClient } from '../../../apiClient'
import { USE_GET_PROGRAM_ONTOLOGY_KEY } from '../useGetCurrentProgramOntologyConfig'
import { OntologyPredictionCorrection } from './ontologyPredictionCorrectionTypings'
import { USE_ONTOLOGY_PREDICTION_CORRECTION_BY_ID_KEY } from './useGetOntologyPredictionCorrectionById'

type EditOntologyPredictionCorrectionPayload = Omit<
  OntologyPredictionCorrection,
  'instances' | 'predictionCorrectionId' | 'programId' | 'criticalErrorDefinitionCount'
>

export function useEditOntologyPredictionCorrection(
  programId?: string,
  predictionCorrectionId?: string,
  onSuccess?: () => void
) {
  const queryClient = useQueryClient()

  return useMutation<unknown, ErrorResponse, EditOntologyPredictionCorrectionPayload>({
    mutationFn: async (values: EditOntologyPredictionCorrectionPayload) => {
      const { data } = await apiClient.put(
        `/int/v3/programs/${programId}/ontology/prediction-corrections/${predictionCorrectionId}`,
        values
      )
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [USE_GET_PROGRAM_ONTOLOGY_KEY] })
      queryClient.invalidateQueries({ queryKey: [USE_ONTOLOGY_PREDICTION_CORRECTION_BY_ID_KEY] })

      onSuccess?.()
    },
  })
}
